import '@babel/polyfill';
import 'animate.css';
import 'bootstrap';
import React from 'react';
import { render } from 'react-dom';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga4';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import Alerta from 'Component/Alerta';
import Rota from 'Router';
import { persistor, store } from 'Store';

import './bootstrap';

import 'Style/app.scss';

ReactGA.initialize('G-RBZ7W70LEC');
ReactPixel.init('3310174355869501');

render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Alerta>
          <BrowserRouter>
            <Rota />
          </BrowserRouter>
        </Alerta>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('app')
);
